import { render, staticRenderFns } from "./HighlightedText.vue?vue&type=template&id=7888f1bc&"
import script from "./HighlightedText.vue?vue&type=script&lang=ts&"
export * from "./HighlightedText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports